import { startOfMonth, endOfDay, endOfMonth, subMonths } from 'date-fns';

export const billingDateRange = () => {
	const currentDate = new Date();
	const lastMonthFirstDay = startOfMonth(subMonths(currentDate, 1));
	const lastMonthLastDay = endOfDay(endOfMonth(subMonths(currentDate, 1)));
	const dateRange = {
		from: lastMonthFirstDay,
		to: lastMonthLastDay,
	};

	return JSON.stringify(dateRange);
};

/** Admin projects list filtered by an org or user uuid. */
export const adminProjectsUrl = uuid => `/admin/projects/?search=${uuid}`;

/** Admin billing view for last month (archived included), filtered by an org or user uuid. */
export const adminBillingUrl = uuid =>
	`${adminProjectsUrl(uuid)}&showArchived=true&mode=billing&dateRange=${billingDateRange()}`;
